<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="myusers f-c-b f-d-c w-100 p-3 h-100">
      <div
        id="reports"
        class="w-100 f-c-s f-d-c mt-4"
        style="padding-bottom: 4rem"
      >
        <div class="f-c-s w-100 searchLine mb-3">
          <div class="label f-c-c ml-2">سازمان :</div>
          <select class="sessionGroup" v-model="groupSelected">
            <option
              v-for="(v, i) in allUserOrg.organ_list"
              :key="i"
              :value="v.id"
            >
              {{ v.title }}
            </option>
          </select>
        </div>
        <div class="excelSec w-100 f-c-b">
          <div class="tableTitle f-c-c">حضور و غیاب</div>
          <a
            v-if="user.permissions.excel_export && getReportsStatus.excel"
            :href="getReportsStatus.excel"
            class="exportExcel f-c-c"
            download
          >
            خروجی اکسل
          </a>
          <a
            v-else
            href="#"
            class="exportExcelEmpty f-c-c"
            @click="emptyExcelFunc()"
          >
            خروجی اکسل
          </a>
        </div>
        <div class="userTable f-c-c f-d-c w-100 mt-2">
          <div class="header f-c-s w-100">
            <div class="headerItem f-c-s"></div>
            <div class="headerItem f-c-s">جلسه</div>
            <div class="headerItem f-c-s w-20">سانس</div>
            <div class="headerItem f-c-s w-25">نام</div>
            <div class="headerItem f-c-s w-18">مدت</div>
          </div>
          <div
            v-if="itemsForList.length"
            class="tableContent f-c-c f-d-c w-100"
          >
            <div
              v-for="(v, i) in itemsForList"
              :key="i"
              class="tableRow f-c-s w-100"
            >
              <div class="tableItem f-c-c">{{ v.row }}</div>
              <div class="tableItem f-c-s">
                {{ v ? v.session_title : "-" }}
              </div>
              <div class="tableItem f-c-s w-20">
                {{ v.session_sans ? v.session_sans : "-" }}
              </div>
              <div class="tableItem f-c-s w-25">
                {{ v.name ? v.name : "-" }}
              </div>
              <div class="tableItem f-c-s w-18">
                {{ v.duration ? v.duration : "-" }}
              </div>
            </div>
          </div>
          <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
            گزارشی وجود ندارد.
          </div>
          <div class="paginationSection f-c-c w-100">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
        <div
          v-if="mobileGroupList && mobileGroupList.length"
          class="mobileUserTable f-c-s f-d-c w-100"
        >
          <div
            v-for="(v, i) in mobileGroupList"
            :key="i"
            class="tableItem f-c-s f-d-c w-100 mb-3"
          >
            <div class="up f-c-b w-100 mb-3">
              <div class="right f-s-s f-d-c">
                <div class="labelItem f-c-c mb-2">جلسه :</div>
                <div class="labelItem f-c-c mb-2">سانس :</div>
                <div class="labelItem f-c-c mb-2">نام :</div>
                <div class="labelItem f-c-c">مدت :</div>
              </div>
              <div class="left f-e-e f-d-c">
                <div class="answerItem f-c-e mb-2">
                  {{ v.session_title }}
                </div>
                <div class="answerItem f-c-e mb-2">
                  {{ v.session_sans }}
                </div>
                <div class="answerItem f-c-e mb-2">
                  {{ v.name }}
                </div>
                <div class="answerItem f-c-e">
                  {{ v.duration }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
        >
          گزارشی وجود ندارد.
        </div>
      </div>
      <div class="gapMaterial f-c-c w-100">
        <div class="text blueText f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapState, mapActions } from "vuex";
// import { EventBus } from "@/assistant/EventBus";
export default {
  name: "PresenceAbsence",
  data() {
    return {
      groupSelected: "",
      currentPage: 1,
      perPage: 15,
      mobileGroupList: [],
      groupList: [],
    };
  },
  created() {
    this.getAllUserOrgFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allUserOrg: (state) => state.gap.allUserOrg,
      getReportsStatus: (state) => state.gap.getReportsStatus,
    }),
    rows() {
      if (this.groupList) {
        return this.groupList.length;
      } else {
        return 0;
      }
    },
    itemsForList() {
      if (this.groupList) {
        return this.groupList.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
      } else {
        return [];
      }
    },
  },
  components: {},
  methods: {
    ...mapActions("gap", ["getAllUserOrgFunction", "getReportsFunction"]),
    emptyExcelFunc() {
      if (!this.getReportsStatus.excel) {
        this.$bvToast.toast("فایلی موجود نیست.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
  },
  watch: {
    getReportsStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groupList = n.report;
          this.mobileGroupList = n.report;
        } else {
          this.groupList = [];
          this.mobileGroupList = [];
        }
      }
    },
    allUserOrg(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groupSelected = n.organ_list[0].id;
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    groupSelected(n) {
      this.getReportsFunction({
        user_id: this.user.user_id,
        organ_id: n,
      });
    },
  },
  mounted() {},
};
</script>